"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.AuthContext = void 0;
const errors_1 = require("../errors");
const react_1 = __importStar(require("react"));
const createCodeChallenge_1 = __importDefault(require("@sportnet/auth/createCodeChallenge"));
const getLoginUrl_1 = __importDefault(require("@sportnet/auth/getLoginUrl"));
const getLogoutUrl_1 = __importDefault(require("@sportnet/auth/getLogoutUrl"));
const getTokens_1 = __importDefault(require("../getTokens"));
const jwt_decode_1 = require("jwt-decode");
const refreshToken_1 = __importDefault(require("../refreshToken"));
const validateIdToken_1 = __importDefault(require("@sportnet/auth/validateIdToken"));
const authorizeAccessToken_1 = __importDefault(require("@sportnet/auth/authorizeAccessToken"));
const generateRandomBytes = (length = 32) => {
    const randomWords = [];
    const characters = '0123456789abcdef';
    for (let i = 0; i < length; i++) {
        const randomChar = characters.charAt(Math.floor(Math.random() * characters.length));
        randomWords.push(randomChar);
    }
    return randomWords.join('');
};
const storageKey = (tokenType, app, ppo) => {
    return ppo ? `${tokenType}_${app}_${ppo}` : `${tokenType}_${app}`;
};
exports.AuthContext = (0, react_1.createContext)({
    app: '',
    isBrowser: false,
    logout: () => { },
    generateLoginUrl: () => '',
    loginUrl: '',
    logoutUrl: '',
    authState: 'authorizing',
});
const AuthProvider = ({ children, app, ppo, optional = false, onAuthorize, onInit, refreshIntervalMs, requiredRoles, routerType = 'path', scopes = [], }) => {
    const [isBrowser, setIsBrowser] = react_1.default.useState(false);
    const [authState, setAuthState] = react_1.default.useState('authorizing');
    const [authCodeError, setAuthCodeError] = react_1.default.useState('');
    const logoutUrl = react_1.default.useMemo(() => (0, getLogoutUrl_1.default)(), []);
    const [invalidRights, setInvalidRights] = react_1.default.useState(false);
    const generateLoginUrl = react_1.default.useCallback((redirectUri) => {
        if (isBrowser) {
            const codeVerifier = window.localStorage.getItem('code_verifier') || generateRandomBytes();
            window.localStorage.setItem('code_verifier', codeVerifier);
            const codeChallenge = (0, createCodeChallenge_1.default)(codeVerifier);
            return (0, getLoginUrl_1.default)({
                app,
                ppo,
                codeChallenge,
                redirectUri: `${window.location.origin}${routerType === 'path' ? '/' : `${window.location.pathname}#`}_auth`,
                openId: true,
                scope: scopes.filter((e) => !!e).join(' '),
                state: redirectUri ||
                    `${window.location.pathname}${window.location.search}`,
            });
        }
        return '';
    }, [app, ppo, isBrowser]);
    react_1.default.useEffect(() => {
        if (!!onInit && isBrowser) {
            onInit({ generateLoginUrl });
        }
    }, [generateLoginUrl, isBrowser, onInit]);
    react_1.default.useEffect(() => {
        setIsBrowser(true);
    }, []);
    const calcTimeout = (accessToken) => {
        return (0, jwt_decode_1.jwtDecode)(accessToken).exp * 1000 - new Date().getTime() - 60000;
    };
    const [accessTokenState, setAccessToken] = react_1.default.useState();
    const authUser = react_1.default.useMemo(() => {
        if (isBrowser) {
            const idt = localStorage.getItem(storageKey('IDT', app, ppo));
            return idt ? (0, validateIdToken_1.default)(idt) : undefined;
        }
    }, [isBrowser, ppo]);
    const accessToken = react_1.default.useMemo(() => {
        if (isBrowser) {
            return accessTokenState;
        }
    }, [accessTokenState, isBrowser]);
    const logout = react_1.default.useCallback((redirectUri) => {
        if (isBrowser) {
            sessionStorage.removeItem(storageKey('AT', app, ppo));
            localStorage.removeItem(storageKey('IDT', app, ppo));
            localStorage.removeItem(storageKey('RT', app, ppo));
            window.location.href = (0, getLogoutUrl_1.default)(redirectUri || window.location.href);
        }
    }, [isBrowser, ppo]);
    const exposed = react_1.default.useMemo(() => ({
        app,
        generateLoginUrl,
        ppo,
        logoutUrl,
        logout,
        accessToken,
        authUser,
        authState,
        isBrowser,
    }), [
        app,
        accessToken,
        authState,
        authUser,
        generateLoginUrl,
        isBrowser,
        logout,
        logoutUrl,
        ppo,
    ]);
    const handleRefreshToken = react_1.default.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (isBrowser) {
            const refreshToken = localStorage.getItem(storageKey('RT', app, ppo)) || undefined;
            return yield (0, refreshToken_1.default)(app, ppo, refreshToken)
                .then((res) => {
                if (res === null || res === void 0 ? void 0 : res.refresh_token) {
                    localStorage.setItem(storageKey('RT', app, ppo), res.refresh_token || '');
                }
                if (res === null || res === void 0 ? void 0 : res.id_token) {
                    localStorage.setItem(storageKey('IDT', app, ppo), res.id_token || '');
                }
                if (!!(res === null || res === void 0 ? void 0 : res.access_token)) {
                    sessionStorage.setItem(storageKey('AT', app, ppo), res.access_token || '');
                    setAccessToken(res.access_token);
                    !!onAuthorize &&
                        onAuthorize({ accessToken: res.access_token, authUser });
                    setAuthState('authorized');
                    const timeout = refreshIntervalMs || calcTimeout(res.access_token);
                    if (timeout > 0) {
                        setTimeout(() => {
                            handleRefreshToken();
                        }, timeout);
                    }
                    else {
                        handleRefreshToken();
                    }
                }
            })
                // ak nemam refreshtoken alebo pri refreshTokene bola 401, stav sa meni na 'unauthorized'
                .catch((err) => {
                var _a;
                if ((err === null || err === void 0 ? void 0 : err.message) === 'RefreshTokenResponseError' &&
                    ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === errors_1.HTTP_CODES.UNAUTHORIZED) {
                    sessionStorage.removeItem(storageKey('AT', app, ppo));
                    localStorage.removeItem(storageKey('IDT', app, ppo));
                    localStorage.removeItem(storageKey('RT', app, ppo));
                    setAuthState('unauthorized');
                    if (!optional) {
                        window.location.href = generateLoginUrl();
                    }
                }
                else {
                    console.error(err);
                    window.alert('Niečo sa pokazilo');
                }
            });
        }
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [app, ppo, generateLoginUrl, optional, isBrowser, refreshIntervalMs]);
    const authorize = react_1.default.useCallback((redirectUri) => __awaiter(void 0, void 0, void 0, function* () {
        if (isBrowser) {
            const accessToken = sessionStorage.getItem(storageKey('AT', app, ppo));
            const refreshToken = localStorage.getItem(storageKey('RT', app, ppo));
            // ak mam accesstoken a je platny tak setAuthState('authorized') a nastavia sa parametre a onAuthorized.
            if (!!accessToken &&
                new Date().getTime() < (0, jwt_decode_1.jwtDecode)(accessToken).exp * 1000 - 60000) {
                try {
                    (0, authorizeAccessToken_1.default)(accessToken, {
                        app,
                        ppo,
                        roles: requiredRoles,
                    });
                    setAccessToken(accessToken);
                    !!onAuthorize && onAuthorize({ accessToken, authUser });
                    setAuthState('authorized');
                    const timeout = refreshIntervalMs || calcTimeout(accessToken);
                    if (timeout > 0) {
                        setTimeout(() => {
                            handleRefreshToken();
                        }, timeout);
                    }
                    else {
                        handleRefreshToken();
                    }
                }
                catch (e) {
                    sessionStorage.removeItem(storageKey('AT', app, ppo));
                    localStorage.removeItem(storageKey('IDT', app, ppo));
                    localStorage.removeItem(storageKey('RT', app, ppo));
                    setAuthState('unauthorized');
                    setInvalidRights(true);
                }
                // ak nemam accesstoken alebo je neplatny, ale mam refresh token zavolam handleRefreshToken().
            }
            else if (!!refreshToken) {
                yield handleRefreshToken();
                // ak nemam refreshtoken alebo pri refreshTokene bola 401, stav sa meni na 'unauthorized'
            }
            else {
                sessionStorage.removeItem(storageKey('AT', app, ppo));
                localStorage.removeItem(storageKey('IDT', app, ppo));
                localStorage.removeItem(storageKey('RT', app, ppo));
                setAuthState('unauthorized');
                if (!optional) {
                    window.location.href = generateLoginUrl(redirectUri);
                }
            }
        }
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ppo,
        handleRefreshToken,
        generateLoginUrl,
        isBrowser,
        optional,
        refreshIntervalMs,
    ]);
    react_1.default.useEffect(() => {
        if ((routerType === 'path' && window.location.pathname !== '/_auth') ||
            (routerType === 'hash' && window.location.hash !== '#_auth')) {
            authorize();
        }
    }, [authorize]);
    react_1.default.useEffect(() => {
        if ((routerType === 'path' && window.location.pathname === '/_auth') ||
            (routerType === 'hash' && window.location.hash === '#_auth')) {
            const searchParams = new URLSearchParams(window.location.search);
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const codeVerifier = window.localStorage.getItem('code_verifier');
            window.localStorage.removeItem('code_verifier');
            if (!!code) {
                (0, getTokens_1.default)(app, code, codeVerifier)
                    .then((tokens) => {
                    if (tokens === null || tokens === void 0 ? void 0 : tokens.access_token) {
                        const { azp: ppo } = (0, jwt_decode_1.jwtDecode)(tokens['access_token']);
                        sessionStorage.setItem(storageKey('AT', app, ppo), tokens.access_token || '');
                        if (tokens === null || tokens === void 0 ? void 0 : tokens.refresh_token) {
                            localStorage.setItem(storageKey('RT', app, ppo), tokens.refresh_token || '');
                        }
                        else {
                            localStorage.removeItem(storageKey('RT', app, ppo));
                        }
                        if (tokens === null || tokens === void 0 ? void 0 : tokens.id_token) {
                            localStorage.setItem(storageKey('IDT', app, ppo), tokens.id_token || '');
                        }
                        else {
                            localStorage.removeItem(storageKey('IDT', app, ppo));
                        }
                        window.history.replaceState(window.history.state, '', '/');
                        window.location.href = state || `/`;
                    }
                })
                    .catch((err) => __awaiter(void 0, void 0, void 0, function* () {
                    var _a, _b, _c, _d;
                    if ((err === null || err === void 0 ? void 0 : err.message) === 'AuthorizationCodeResponseError' &&
                        (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === errors_1.HTTP_CODES.FORBIDDEN ||
                            ((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.status) === errors_1.HTTP_CODES.BAD_REQUEST)) {
                        setAuthState('unauthorized');
                        setAuthCodeError('Autorizácia sa nepodarila: ' +
                            ((_d = (yield ((_c = err.response) === null || _c === void 0 ? void 0 : _c.json()))) === null || _d === void 0 ? void 0 : _d.description) ||
                            err.response.status ||
                            'neznáma chyba');
                    }
                    else {
                        setAuthCodeError('Autorizácia sa nepodarila');
                        console.error(err);
                    }
                }));
            }
            else {
                setAuthCodeError('Autorizácia sa nepodarila');
            }
        }
    }, [app, ppo]);
    if (isBrowser &&
        ((routerType === 'path' && window.location.pathname === '/_auth') ||
            (routerType === 'hash' && window.location.hash === '#_auth'))) {
        return authCodeError ? (react_1.default.createElement(react_1.default.Fragment, null,
            authCodeError,
            react_1.default.createElement("br", null),
            react_1.default.createElement("button", { onClick: () => {
                    window.history.back();
                } }, "Vr\u00E1ti\u0165 sa sp\u00E4\u0165"))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }
    if (invalidRights) {
        return (react_1.default.createElement("div", { style: {
                textAlign: 'center',
            } },
            react_1.default.createElement("br", null),
            react_1.default.createElement("h1", null, "Neplatn\u00E9 pr\u00E1va"),
            react_1.default.createElement("p", null, "Pre t\u00FAto str\u00E1nku nem\u00E1te dostato\u010Dn\u00E9 pr\u00E1va"),
            react_1.default.createElement("br", null),
            react_1.default.createElement("button", { onClick: () => {
                    logout();
                } }, "Odhl\u00E1si\u0165 sa")));
    }
    return (react_1.default.createElement(exports.AuthContext.Provider, { value: exposed }, optional ? (children) : authState === 'authorized' ? (children) : authState === 'unauthorized' ? (react_1.default.createElement(react_1.default.Fragment, null, "authorizing...")) : (react_1.default.createElement(react_1.default.Fragment, null, "unauthorized"))));
};
const useAuth = () => react_1.default.useContext(exports.AuthContext);
exports.useAuth = useAuth;
exports.default = AuthProvider;
